import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import AccountSetup from './pages/AccountSetup';
import VehicleManagement from './pages/VehicleManagement';
import Crm from './pages/Crm';
import CustomerEditor from './pages/CustomerEditor';
import CustomerView from './pages/CustomerView';
import Logs from './pages/Logs';
import ActivityLogs from './pages/ActivityLogs';
import OrderManagement from './pages/OrderManagement';
import AppointmentsPage from './pages/AppointmentsPage';
import AppointmentEditPage from './pages/AppointmentEditPage';
import AppointmentViewPage from './pages/AppointmentViewPage';
import NewAppointmentPage from './pages/NewAppointmentPage';
import AllOrdersPage from './pages/orderManagement/AllOrdersPage';
import PendingOrdersPage from './pages/orderManagement/PendingOrdersPage';
import OrderNewPage from './pages/orderManagement/NewOrderPage';
import OrderView from './pages/orderManagement/OrderView';
import ManagerApprovalStandalone from './pages/orderManagement/ManagerApprovalStandalone';
import CustomerOrderApproval from './pages/customer/CustomerOrderApproval';
import Reports from './pages/Reports';
import SalesPipelinesPage from './pages/salesPipelines/SalesPipelinesPage';
import ProtectedRoute from './components/ProtectedRoute';
import AppShell from './components/AppShell';
import HomeRedirect from './components/HomeRedirect';
import VariantRelatedProductsPage from './pages/inventory/VariantRelatedProductsPage';
import SchedulerPage from './pages/scheduler/SchedulerPage';


function App() {
  return (
    <Routes>
      {/* Public customer approval routes (not behind ProtectedRoute) */}
      <Route path="customer/order-approval/:orderId" element={<CustomerOrderApproval />} />
      <Route path="customer/order-approval/:orderId/login" element={<CustomerOrderApproval />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<HomeRedirect />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="inventory/:section" element={<Inventory />} />
        <Route path="inventory/:section/:id" element={<Inventory />} />
        <Route path="inventory/:section/:id/:subsection" element={<Inventory />} />
        <Route path="inventory/variants/:id/related-products" element={<VariantRelatedProductsPage />} />
        <Route path="inventory/service-variants/:id/related-products" element={<VariantRelatedProductsPage />} />
        <Route path="account-setup" element={<AccountSetup />} />
        <Route path="account-setup/:section" element={<AccountSetup />} />
        <Route path="account-setup/:section/:id" element={<AccountSetup />} />
        <Route path="vehicle-management" element={<VehicleManagement />} />
        <Route path="vehicle-management/:section" element={<VehicleManagement />} />
        <Route path="vehicle-management/:section/:id" element={<VehicleManagement />} />
        <Route path="vehicle-management/:section/:id/:subsection" element={<VehicleManagement />} />
        <Route path="crm" element={<Crm />} />
        <Route path="crm/add" element={<CustomerEditor />} />
        <Route path="crm/:customerId" element={<CustomerEditor />} />
        <Route path="crm/view/:customerId" element={<CustomerView />} />
        <Route path="logs" element={<Logs />} />
        <Route path="activity" element={<ActivityLogs />} />
        <Route path="sales-pipelines" element={<SalesPipelinesPage />} />
        <Route path="order-management" element={<AllOrdersPage />} />
        <Route path="order-management/pending" element={<PendingOrdersPage />} />
        <Route path="order-management/new" element={<Navigate to="/order-management/new/customer-vehicle" replace />} />
        <Route path="order-management/new/:step" element={<OrderNewPage />} />
        <Route path="order-management/:orderId" element={<OrderView />} />
        <Route path="order-management/manager-approval/:orderId" element={<ManagerApprovalStandalone />} />
        <Route path="appointments" element={<AppointmentsPage />} />
        <Route path="appointments/new" element={<NewAppointmentPage />} />
        <Route path="appointments/:appointmentId" element={<AppointmentViewPage />} />
        <Route path="appointments/:appointmentId/edit" element={<AppointmentEditPage />} />
        <Route path="scheduler" element={<SchedulerPage />} />
        <Route path="reports" element={<Reports />} />

      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
